import React from "react";
import { Badge } from "./Badge";
import { capitalize } from "../../utils/helpers";

export const EVENT_STATUS_META = {
  active: { label: "Active", variant: "success" },
  pending: { label: "Pending", variant: "warning" },
  duplicate: { label: "Duplicate", variant: "destructive" },
  hidden: { label: "Hidden", variant: "secondary" },
  // Derived by the API (`display_status`): every occurrence cancelled, not merged away.
  cancelled: { label: "Cancelled", variant: "outline" },
  // The event is gone from the index: a null status, or `deleted` from the possible-duplicates queue.
  deleted: { label: "Deleted", variant: "destructive" },
};

// Alerts stay open on pending and hidden events on purpose — hiding is how an admin parks
// an event to work on it — so every alert queue shows the event's status and the human decides.
export const EventStatusBadge = ({ status }) => {
  const key = (status || "deleted").toLowerCase();
  const meta = EVENT_STATUS_META[key] || { label: capitalize(key), variant: "secondary" };
  return (
    <Badge variant={meta.variant} className="shrink-0 text-[10px] py-0">
      {meta.label}
    </Badge>
  );
};

export default EventStatusBadge;
